import * as React from 'react';
import { Box, Skeleton, useTheme } from '@mui/material';
import { CustomAvatar } from '../../molecules';
import { type UserCardUserType } from '../UserContactCard';

export interface AssistanceCardContactItemProps {
    title: string;
    description: string;
    userData: UserCardUserType | null;
    isLoading: boolean;
    onClick: () => void;
}

export const AssistanceCardContactItem: React.FunctionComponent<AssistanceCardContactItemProps> =
    function ({ title, description, userData, isLoading, onClick }) {
        const theme = useTheme();

        const isDataLoaded = userData && (userData.firstName || userData.lastName || userData.mail);

        const renderAvatar = () => {
            if (!isDataLoaded && isLoading) {
                return (
                    <Skeleton
                        variant="circular"
                        sx={{ width: '48px', height: '48px', flexShrink: 0 }}
                    />
                );
            }

            if (userData) {
                return (
                    <CustomAvatar
                        firstName={userData.firstName}
                        lastName={userData.lastName}
                        keycloakId={userData.userIdentifier}
                        sx={{
                            width: '48px',
                            height: '48px',
                            flexShrink: 0,
                        }}
                    />
                );
            }

            return (
                <CustomAvatar
                    sx={{
                        width: '48px',
                        height: '48px',
                        flexShrink: 0,
                    }}
                />
            );
        };

        return (
            <Box
                onClick={onClick}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                    cursor: 'pointer',
                    padding: '16px 0',
                    borderTop: `1px solid ${theme.palette.grey[200]}`,
                    borderBottom: `1px solid ${theme.palette.grey[200]}`,
                    textAlign: 'left',
                }}
            >
                {renderAvatar()}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        textAlign: 'left',
                        minWidth: 0,
                        width: '100%',
                    }}
                >
                    <Box
                        component="span"
                        sx={{
                            variant: 'l2dh7',
                            fontSize: '1rem',
                            fontWeight: 600,
                            textAlign: 'left',
                        }}
                    >
                        {title}
                    </Box>
                    <Box
                        component="span"
                        sx={{
                            fontSize: '0.875rem',
                            color: theme.palette.grey[600],
                            textAlign: 'left',
                        }}
                    >
                        {description}
                    </Box>
                </Box>
            </Box>
        );
    };
